// src/App.js
import { useEffect } from "preact/hooks";
import OnlineBookingContainer from "./OnlineBookingContain";
import { LocationProvider } from "../context/LocationContext";

function App() {
  // Nothing on this page is meant to be reached by scrolling sideways, and
  // with the overflow clipped the user could not undo a sideways offset
  // anyway. Chrome still restores the offset a page had before a reload, and
  // it does so once the document has its final size, which is after this
  // component mounts, so a one-time reset on mount was too early. Instead the
  // page is held at the left edge for as long as it is open, and the browser
  // is told not to restore scroll positions at all.
  useEffect(() => {
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    const keepLeft = () => {
      if (window.scrollX) window.scrollTo(0, window.scrollY);
    };
    keepLeft();
    window.addEventListener("scroll", keepLeft, { passive: true });
    window.addEventListener("load", keepLeft);
    return () => {
      window.removeEventListener("scroll", keepLeft);
      window.removeEventListener("load", keepLeft);
    };
  }, []);

  return (
    <LocationProvider>
      <OnlineBookingContainer />
    </LocationProvider>
  );
}

export default App;
